var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebabBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "14px",
    viewBox: "0 0 4 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-More-Menu-Bold",
    transform: "translate(-12.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ellipsis-special",
    transform: "translate(14.000000, 14.000000) rotate(-90.000000) translate(-14.000000, -14.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-path kebab-icon",
    d: "M14,15.1666667 C13.3556678,15.1666667 12.8333333,14.6443322 12.8333333,14 C12.8333333,13.3556678 13.3556678,12.8333333 14,12.8333333 C14.6443322,12.8333333 15.1666667,13.3556678 15.1666667,14 C15.1666667,14.6443322 14.6443322,15.1666667 14,15.1666667 Z M21,14 C21,13.3556678 20.4776655,12.8333333 19.8333333,12.8333333 C19.1890011,12.8333333 18.6666667,13.3556678 18.6666667,14 C18.6666667,14.6443322 19.1890011,15.1666667 19.8333333,15.1666667 C20.4776655,15.1666667 21,14.6443322 21,14 Z M9.33333333,14 C9.33333333,13.3556678 8.81099887,12.8333333 8.16666667,12.8333333 C7.52233446,12.8333333 7,13.3556678 7,14 C7,14.6443322 7.52233446,15.1666667 8.16666667,15.1666667 C8.81099887,15.1666667 9.33333333,14.6443322 9.33333333,14 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabBold);
export default __webpack_public_path__ + "static/media/kebab-bold.75f5f8f41a54b3b9d9f2c90e9e8657eb.svg";
export { ForwardRef as ReactComponent };